<template>
  <div class="video-cutting__wrapper">
    <el-dialog
      :show-close="false"
      :visible.sync="originalVideoModal.open"
      width="1119px">
      <div class="close-video crop-video" @click="showFrames(originalVideoModal.id)">
        <svgicon name="crop"></svgicon>
      </div>
      <div class="close-video" @click="originalVideoModal = { open: false, src: '', id: null }">
        <svgicon name="Close"></svgicon>
      </div>
      <video class="video-video" :src="originalVideoModal.src" controls></video>
    </el-dialog>
    <el-dialog
      :show-close="false"
      :visible.sync="addTagModal"
      width="470px">
      <template slot="title">
        <div class="modal-title acr-bold-22">
          <div>
            <div class="modal-btn" @click="addTagModal = false">
              <svgicon name="Chevron-left"></svgicon>
            </div>
            <span>Add new tag</span>
          </div>
          <div class="modal-btn" :class="{'active': newTag}" @click="addGroupTag">
            <svgicon name="Arrow-right"></svgicon>
          </div>
        </div>
      </template>
      <div class="modal-field">
        <div class="modal-field__label acr-bold-18">Tag name</div>
        <el-input label="Project name" v-model="newTag"></el-input>
      </div>
    </el-dialog>
    <BaseLoader v-if="!project"/>
    <div class="video-cutting" :class="{'min': showFilter}" v-if="project">
      <div class="video-cutting__heading">
        <div style="display: flex;align-items: center">
          <!--<div class="brand-detection__btn" @click="filtersApplied ? clearFilters() : router.go(-1)">-->
          <!--<svgicon name="Chevron-left"></svgicon>-->
          <!--</div>-->
          <div class="brand-detection__btn" @click="$router.go(-1)">
            <svgicon name="Chevron-left"></svgicon>
          </div>
          <svgicon name="Cut2" class="video-cutting__icon"></svgicon>
          <div class="brand-detection__title acr-ultra-bold" style="margin-top: -2px;margin-right: 17px">{{project.project_name}}</div>
          <!--<button @click="listView = !listView">list</button>-->
          <BaseToggle @check="listView = true" @uncheck="listView = false"></BaseToggle>
        </div>
        <div style="display: flex;align-items: center">
        <span class="acr-medium acr-bold" style="margin-right: 26px;margin-top: -2px"
              v-if="selectedVideos.length === 0">
            <!--<span v-if="project && project.total_videos && !selectVideosMode">Total: {{project.total_videos}}</span>-->
        </span>
          <div class="video-cutting-option" v-else>
            <div class="video-cutting-option__selected acr-bold" style="margin-right: 20px">Selected:
              {{selectedVideos.length}}
            </div>
            <div class="video-cutting__btn  video-cutting__btn--default acr-bold sm" @click="addTagModal = true">
              <span style="margin-top: -2px">New tag</span>
            </div>
            <div class="video-cutting__btn  video-cutting__btn--transparent"
                 @click="rerenderCards += 1;selectedVideos = []">
              <svgicon name="Close"></svgicon>
            </div>

          </div>
          <el-dropdown trigger="click" @command="rerun">

          <div class="video-cutting__btn">
            <!--<svgicon name="Filter" style="width: 19px;height: 19px;"></svgicon>-->
              <svgicon name="Setting"></svgicon>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>Re-run analysis</el-dropdown-item>
              </el-dropdown-menu>
          </div>
          </el-dropdown>
        </div>
      </div>
      <BaseScrollbar @scrollyend="handleScrollEnd">
        <div class="content-wrapper content-wrapper__ns video-cutting__content-wrapper">
          <div class="video-cutting__content" :key="rerenderCards" v-if="!loading"
               :class="{'video-cutting__content--list': listView, 'pb150': selectedVideos.length > 0}">
            <div class="video-cutting__card" v-for="(video) in clips" :key="video.id" :class="{'video-cutting__card--list': listView}">
              <div class="video-cutting__card-check" v-if="!downloadingMultiple && !generatingZip && listView">
                <el-checkbox @change="onVideoSelect($event, video)"/>
              </div>
              <div class="video video-cutting__card-video">
                <div class="video-cutting__card-clickable" @click="originalVideoModal = { open: true, src: video.video_url, id: video.id }"></div>
                <!--<div class="video-cutting__card-clickable" @click="showFrames(video.id)"></div>-->
                <div class="video-overlay">
                  <svgicon name="Play" class="video-play"></svgicon>
                  <span class="video-cutting__card-duration"
                        style="margin-right: 7px">{{formatSeconds(video.video_duration_sec)}}
                  </span>
                </div>
                <img :src="video.thumbnail_url" alt="" class="video-src">
              </div>
              <div class="video-cutting__card-info">
                <div class="video-cutting__card-header acr-ultra-bold">
                  <!--{{video.display_name}}-->
                  <!--<div class="video-cutting__card-btns">-->
                  <!--<svgicon name="Download"></svgicon>-->
                  <!--<svgicon name="More2"></svgicon>-->
                  <!--</div>-->
                </div>
                <div class="video-cutting__card-timecode">
                  <div class="video-cutting__card-check" v-if="!downloadingMultiple && !generatingZip && !listView">
                    <el-checkbox @change="onVideoSelect($event, video)"/>
                  </div>
                  <span
                    class="acr-ultra-bold" :style="{'fontSize': listView ? '14px' : '18px'}">[{{formatSeconds(video.start_time)}} - {{formatSeconds(video.end_time)}}]</span>
                </div>
                <div class="video-cutting__card-tags">
                  <div class="video-cutting__card-tag acr-medium" @click="onCheckBoxSelect(true, 'Tags', tag)"
                       v-for="(tag, index) in video.tags"
                       :key="index">{{truncateString(tag, 35)}}
                  </div>
                </div>
              </div>
            </div>
            <SkeletonCard v-for="item in showSkeleton ? 20 : 0" :key="item"></SkeletonCard>
          </div>
          <BaseLoader v-else/>
          <SmallFooter></SmallFooter>
        </div>
      </BaseScrollbar>
    </div>
    <BaseFilter :show-filter="showFilter" :show-sorting="true" :filter-analytic="true" :one-column="true"
                @sort="sorting = $event" @close="showFilter = false" :key="filtersKey">
      <div>
        <div class="filter__subtitle acr-medium-18">Scenes</div>
        <div>
          <el-checkbox-group v-model="selectedFilters">
            <el-checkbox
              :label="values.label"
              v-for="values in filters" :key="values.value"><span class="acr-medium">{{ values.label }}</span>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div v-for="filter in asideFilters" :key="filter.item_label">
        <div style="display: flex;flex-direction: column"
             v-if="filter.filter_var && filter.filter_var !== 'exclude_videos_by_duration'">
          <div class="filter__subtitle acr-medium-18" v-if="filter.item_label">{{filter.item_label}}</div>
          <el-checkbox
            dark
            :val="item"
            @change="onCheckBoxSelect($event, filter.filter_var, item)"
            v-for="item in filter.filter_values" :key="item"><span
            class="acr-medium">{{truncateString(item, 25)}}</span></el-checkbox>
        </div>
        <div style="display: flex;flex-direction: column" v-else>
          <div class="filter__subtitle acr-medium-18">exclude video less than</div>
          <div class="filter__input--wrapper">
            <input
              type="number"
              min="0"
              class="filter__input"
              v-model="excludeVideosUnder"
              @input="onExcludeVideosUnder">
            <span>sec</span>
          </div>
        </div>
      </div>
      <div class="filter-btn acr-bold" slot="clear" v-if="filtersApplied" @click="clearFilters">Clean</div>
    </BaseFilter>
    <portal to="app">
    <footer class="footer" style="padding-top: 21px" v-if="selectedVideos.length > 0">
      <div class="footer-header">
        <div class="footer-title acr-bold-22">Selected videos</div>
        <div style="display: flex;align-items: center">
          <el-dropdown v-if="!downloadingMultiple && !generatingZip" trigger="hover" @command="handleDownloadCommand">
            <div class="video-cutting-export">
              <span style="margin-top: -2px">Download</span>
              <div class="video-cutting-export-select">
                <svgicon name="ArrowDown"></svgicon>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="archive">Archive</el-dropdown-item>
              <el-dropdown-item command="series">In series</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="progress-btn" v-else>
            <div class="progress-btn__text acr-bold" v-if="downloadingMultiple">
              Downloading
            </div>
            <div class="progress-btn__text acr-bold" v-if="generatingZip">
              Archiving
            </div>
            <div class="progress-btn__progress" :style="{'width': (processingProgress * 100) / videosToProcessAmount + '%'}"></div>
          </div>
          <!--<div class="footer-btn close" v-if="showClose" @click="$emit('close')">-->
          <!--<svgicon name="Close"></svgicon>-->
          <!--</div>-->
        </div>
      </div>
      <DownloadVideoFooter :selectedVideos="selectedVideos"/>
    </footer>
    </portal>
  </div>
</template>

<script>
  import {
    getProjectById,
    getProjectFilters,
    getFilteredProject,
    downloadProjectReport,
    rerunProject,
    duplicateProject,
    fetchSuggestionInProject
  } from "../../api/projects";
  import {getAugmentedVideo, editAugumentedVideo, removeTag, reportIssue, deleteAugmentedVideo} from "../../api/files";
  import {formatSeconds} from "../../utils/utils";
  import {mapActions} from 'vuex';
  import JSZip from 'jszip'
  import FileSaver from 'file-saver';
  import BaseFilter from '../../components/BaseFilter';
  import BaseToggle from '../../components/BaseToggle';
  import BaseLoader from '../../components/BaseLoader';
  import BaseScrollbar from '../../components/BaseScrollbar';
  import SkeletonCard from '../../components/SkeletonCard';
  import SmallFooter from '../../components/footer/SmallFooter';
  import DownloadVideoFooter from '../../components/footer/DownloadVideoFooter';

  export default {
    name: "VideoCutting",
    components: {BaseFilter, BaseScrollbar, SkeletonCard, BaseLoader, BaseToggle, SmallFooter, DownloadVideoFooter},
    data() {
      return {
        listView: false,
        search: '',
        filtersKey: 0,
        sliderVisible: false,
        showBoundingBox: true,
        generatingZip: false,
        signalControllers: [],
        downloadingMultiple: false,
        processingProgress: 0,
        videosToProcessAmount: 0,
        showFilter: true,
        asideFilters: [],
        asideFiltersSelected: {},
        selectedFilters: [],
        filters: [],
        project: null,
        clips: [],
        selectedClip: null,
        selectedClipAug: null,
        selectedClipNewName: null,
        newTag: '',
        loading: true,
        editClipDialog: false,
        reportClipDialog: false,
        reportReasons: [],
        skip: 0,
        deleteClipDialog: false,
        addTagModal: false,
        selectedVideos: [],
        selectVideosMode: false,
        rerenderCards: 0,
        excludeVideosUnder: '',
        showSkeleton: false,
        sorting: '',
        originalVideoModal: {
          open: false,
          src: ''
        },
      }
    },
    watch: {
      excludeVideosUnder(v) {
        if (!v && this.query.exclude_videos_by_duration) {
          delete this.query.exclude_videos_by_duration;
          delete this.asideFiltersSelected.exclude_videos_by_duration;
        }
      },
      selectVideosMode(v) {
        if (!v) this.selectedVideos = [];
      },
      query(v) {
        if (this.timeout)
          clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.loading = true;
          if (Object.keys(v).length > 0) {
            getFilteredProject(this.$route.params.projectId, v, this.sorting).then((res) => {
              this.clips = res.data.videos;
              this.loading = false;
            })
          } else {
            this.clips = [];
            this.skip = 0;
            this.getClips();
          }
        }, 300);
      },
      sorting() {
        this.loading = true;
        this.clips = [];
        this.skip = 0;
        this.getClips();
      },
      selectedClip(v) {
        this.updateSelectedAugClip(this.clips[v].id);
      },
    },
    computed: {
      filtersApplied() {
        return this.selectedFilters.length > 0 || this.search.length > 0 || this.transformedAsideFilters.length > 0;
      },
      transformedAsideFilters() {
        const arrayOfAsideFilters = Object.keys(this.asideFiltersSelected).map((item) => {
          return {[item]: Object.keys(this.asideFiltersSelected[item]).filter((x) => !!this.asideFiltersSelected[item][x]).join()};
        });

        return arrayOfAsideFilters
      },
      query() {
        const queryObject = {
          ...(this.selectedFilters.length && {event: this.selectedFilters.join()}),
          ...(this.search.length > 0 && {name: this.search}),
        };

        this.transformedAsideFilters.forEach((item) => {
          queryObject[Object.keys(item)[0].toLowerCase()] = item[Object.keys(item)[0]];
        });

        return queryObject
      }
    },
    created() {
      this.getClips();
      this.getFilters();
    },
    beforeRouteEnter(to, from, next) {
      if (to.params && (to.params.clipIndex || to.params.clipIndex === 0)) {
        next(vm => {
          setTimeout(() => {
            vm.viewClip(to.params.clipIndex)
          }, 1500)
        })
      }
      next()
    },
    beforeDestroy() {
      this.signalControllers.forEach(c => c.abort());
    },
    methods: {
      onExcludeVideosUnder() {
        if (!this.excludeVideosUnder) {
          return this.onCheckBoxSelect(false, 'exclude_videos_by_duration', '');
        }

        if (this.asideFiltersSelected.exclude_videos_by_duration) {
          delete this.asideFiltersSelected.exclude_videos_by_duration;
        }

        this.onCheckBoxSelect(true, 'exclude_videos_by_duration', '0-' + this.excludeVideosUnder)
      },
      truncateString(str, num) {
        if (str.length > num) {
          return str.slice(0, num) + "...";
        } else {
          return str;
        }
      },
      addGroupTag(e) {
        if (e) e.stopPropagation();

        let promiseArr = [];
        let formD = new FormData();
        formD.append('tag', this.newTag);

        const addTag = (v) => {
          return new Promise((resolve, reject) => {
            try {
              editAugumentedVideo(v, formD).then(() => resolve());
            } catch (e) {
              reject(e)
            }
          })
        };

        this.selectedVideos.forEach((v) => {
          promiseArr.push(addTag(v.id));
        });

        Promise.all(promiseArr).then(() => {
          this.newTag = '';
          this.addTagModal = false;
          this.selectedVideos = [];
          this.rerenderCards += 1;
          this.skip = 0;
          this.loading = true;
          this.clips = [];
          this.getClips();
          this.getFilters();
        })

      },
      fetchAutocomplete(str, cb) {
        fetchSuggestionInProject(this.$route.params.projectId, str).then((res) => {
          cb(res.data.suggestions)
        });
      },
      handleSelectSuggestion(item) {
        this.search = item;
      },
      formatSeconds(s) {
        return formatSeconds(s);
      },
      onVideoSelect(value, video) {
        const v = typeof value === 'object' ? value.target.checked : value;

        if (v) this.selectedVideos.push(video);
        else this.selectedVideos = this.selectedVideos.filter((i) => i.id !== video.id);
      },
      ...mapActions({
        success: 'success',
        error: 'error',
      }),
      rerun() {
        rerunProject(this.$route.params.projectId).then(() => {
          this.$router.push({name: 'projects'})
        })
      },
      duplicate_project() {
        duplicateProject(this.$route.params.projectId).then(() => {
          this.$router.push({ name: 'projects' })
        })
      },
      showFrames(id) {
        this.$router.push({
          name: 'frame-view',
          params: {
            projectId: this.$route.params.projectId,
            videoId: id,
            type: 'video_analytics',
            clipIndex: 0
          }
        })
      },
      downloadVideo(video) {
        fetch(video.video_url).then((data) => {
          data.arrayBuffer().then((src) => {
            downloadProjectReport(src, `${video.tags[0] || ""}_${video.display_name}`, 'video/mp4');
          })
        });
      },
      handleDownloadCommand(command) {
        if (command === 'archive') {
          this.downloadZip()
        } else {
          this.downloadMultiple()
        }
      },
      downloadZip() {
        if (this.generatingZip) return;

        this.generatingZip = true;
        this.videosToProcessAmount = this.selectedVideos.length + 1;

        let zip = new JSZip();
        let promiseArr = [];

        const addToZip = (v, index) => {
          return new Promise((resolve, reject) => {
            try {
              this.downloadSingle(v, index, false).then((data) => {
                console.log(data);
                resolve(zip.file(`${v.video_name}.mp4`, data, {
                  binary: true,
                  compression: "DEFLATE"
                }));
              });
            } catch (e) {
              reject(e)
            }
          })
        };

        this.selectedVideos.forEach((v, index) => {
          v.toArchive = true;
          promiseArr.push(addToZip(v, index));
        });

        Promise.all(promiseArr).then(() => {
          if (this.selectedVideos.length > 0){
            zip.generateAsync({type: "blob"}).then((content) => {
              FileSaver.saveAs(content, prompt("Archive name"));
              this.generatingZip = false;
              this.selectedVideos = [];
              this.signalControllers = [];
              this.rerenderCards += 1;
              this.processingProgress = 0;
              this.videosToProcessAmount = 0;
            });
          }
        })
      },
      downloadSingle(v, index, save = true) {
        return new Promise((resolve, reject) => {
          try {
            const signalController = new AbortController();
            this.signalControllers.push(signalController);

            fetch(v.video_url, { signal: signalController.signal }).then(async (response) => {
              const reader = response.body.getReader();

              const contentLength = +response.headers.get('Content-Length');

              let receivedLength = 0;
              let chunks = [];

              for (;;) {
                const {done, value} = await reader.read();

                if (done) {
                  break;
                }

                chunks.push(value);
                receivedLength += value.length;

                const percent = (receivedLength * 100) / contentLength

                this.selectedVideos = [
                  ...this.selectedVideos.slice(0,index),
                  { ...v, percent: percent.toFixed()},
                  ...this.selectedVideos.slice(index+1)
                ];
              }

              let chunksAll = new Uint8Array(receivedLength);
              let position = 0;
              for(let chunk of chunks) {
                chunksAll.set(chunk, position);
                position += chunk.length;
              }

              if (save && this.selectedVideos.length > 0) FileSaver.saveAs(new Blob([chunksAll], {type: 'video/mp4'}), `${v.video_name}.mp4`);
              this.processingProgress += 1;
              resolve(chunksAll);
            });
          } catch (e) {
            reject(e)
          }
        })
      },

      downloadMultiple() {
        if (this.downloadingMultiple) return;

        this.downloadingMultiple = true;
        this.videosToProcessAmount = this.selectedVideos.length;
        let promiseArr = [];

        this.selectedVideos.forEach((v, index) => {
          v.percent = 0;
          promiseArr.push(this.downloadSingle(v, index));
        });

        Promise.all(promiseArr).then(() => {
          this.downloadingMultiple = false;
          this.processingProgress = 0;
          this.videosToProcessAmount = 0;
          this.selectedVideos = [];
          this.signalControllers = [];
          this.rerenderCards += 1;
        })

      },
      openReportModal(clipIndex) {
        this.selectedClip = clipIndex;
        this.reportClipDialog = true;
      },
      openDeleteModal(clipIndex) {
        this.selectedClip = clipIndex;
        this.deleteClipDialog = true;
      },
      reportIssue() {
        if (this.reportReasons.length === 0 || this.clips[this.selectedClip].in_feedbacks) {
          return this.error('Select at least 1 reason');
        }

        let formD = new FormData();
        formD.append('project_id', this.$route.params.projectId);
        formD.append('project_type', 'video_analytics');
        formD.append('video_id', this.clips[this.selectedClip].id);
        formD.append('description', this.reportReasons.join());
        reportIssue(formD).then(() => {
          this.success('Report sent');
          this.clips[this.selectedClip].in_feedbacks = true;
          this.selectedClip = null;
          this.reportClipDialog = false;
        });
      },
      handleScrollEnd() {
        if (this.skip > this.clips.length || this.filtersApplied) {
          return;
        }
        this.skip += 20;

        this.getClips(this.skip);
      },
      getClips(skip = 0) {
        if (skip > 0) this.showSkeleton = true;
        getProjectById(this.$route.params.projectId, this.sorting, skip).then((res) => {
          this.project = res.data;
          this.clips = [...this.clips, ...res.data.videos];
          this.loading = false;
          this.showSkeleton = false;
        });
      },
      getFilters() {
        getProjectFilters(this.$route.params.projectId).then((res) => {
          this.filters = res.data.header_filters[0].filter_values;
          this.asideFilters = res.data.left_filters;
          this.filters = this.filters.map((item) => {
            return {label: item.replace(/_/g, ' '), value: item}
          });
        })
      },
      addTag(e) {
        e.stopPropagation();
        let formD = new FormData();
        formD.append('tag', this.newTag);
        editAugumentedVideo(this.selectedClipAug.id, formD).then(() => {
          this.newTag = '';
          this.updateSelectedAugClip(this.selectedClipAug.id);
          this.getFilters();
        });
      },
      editClipName(e) {
        e.stopPropagation();
        let formD = new FormData();
        formD.append('display_name', this.selectedClipNewName);
        editAugumentedVideo(this.selectedClipAug.id, formD).then(() => {
          this.updateSelectedAugClip(this.selectedClipAug.id);
          this.editClipDialog = false;
        });
      },
      removeTag(tag) {
        let formD = new FormData();
        formD.append('tag', tag);
        removeTag(this.selectedClipAug.id, formD).then(() => {
          this.updateSelectedAugClip(this.selectedClipAug.id);
          this.getFilters();
        });
      },
      removeClip() {
        deleteAugmentedVideo(this.clips[this.selectedClip].id).then(() => {
          this.clips.splice(this.selectedClip, 1);
          this.getFilters();
          this.selectedClip = null;
          this.deleteClipDialog = false;
        });
      },
      updateSelectedAugClip(id) {
        getAugmentedVideo(id).then(res => {
          this.selectedClipAug = res.data;
          this.selectedClipNewName = res.data.display_name;
        });
      },
      onCheckBoxSelect(value, filter, field) {
        const v = typeof value === 'object' && !Array.isArray(value) ? value.target.checked : value;
        this.asideFiltersSelected = {
          ...this.asideFiltersSelected,
          [filter]: {
            ...this.asideFiltersSelected[filter],
            [field]: v
          },
        };
      },
      nextClip() {
        if (this.selectedClip !== this.clips.length) {
          this.selectedClip++
        }
      },
      previousClip() {
        if (this.selectedClip !== 0) {
          this.selectedClip--
        }
      },
      viewClip(clipIndex) {
        this.selectedClip = clipIndex;
        this.sliderVisible = true;
      },
      clearFilters() {
        this.selectedFilters = [];
        this.asideFiltersSelected = [];
        this.excludeVideosUnder = '';
        this.search = '';
        this.filtersKey += 1;
      }
    }
  }
</script>

<style scoped lang="scss">
  .video-cutting {

    .pb150 {
      padding-bottom: 150px;
    }

    /deep/
    .el-checkbox {
      &-group {
        display: flex;
        flex-direction: column;
      }

      &.is-checked {
        .el-checkbox__inner {
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;

          &::after {
            width: 14px;
            height: 11px;
            content: url("../../assets/svg/Done.svg");
            transform: scale(1) translate(-50%, -50%);
            border: none;
            left: 50%;
            top: 50%;
          }
        }
      }

      &__inner {
        width: 30px;
        height: 30px;
        border: none;
        background: rgba(36, 49, 67, 0.1);
        opacity: 0.85;
        border-radius: 3px;
        margin-right: 12px;

        &::after {
          width: 14px;
          height: 11px;
          content: url("../../assets/svg/Done.svg");
          transform: scale(0);
          transition: all .3s ease;
          border: none;
        }
      }
    }
  }

  .video-cutting__card--list {
    /deep/
    .el-checkbox {
      &-group {
        display: flex;
        flex-direction: column;
      }

      &.is-checked {
        .el-checkbox__inner {
          width: 26px;
          height: 26px;

          &::after {
            width: 14px;
            height: 11px;
          }
        }
      }

      &__inner {
        width: 26px;
        height: 26px;
        background: white;
        border: 1px solid rgba(36, 49, 67, 0.1);
        border-radius: 3px;

        &:hover {
          background: rgba(36, 49, 67, 0.1);
        }

        &::after {
          width: 14px;
          height: 11px;
        }
      }
    }
  }

  /deep/
  .el-loading-mask {
    background-color: transparent;

    .el-loading-spinner {
      margin-top: -15px;
      margin-left: 5px;
    }

    svg {
      width: 15px;
      height: 15px;
      margin-top: 7px;

      circle {
        stroke: #00204D;
        stroke-width: 6px;

      }
    }
  }
</style>
